import ReactAudioPlayer from 'react-audio-player';

import { IEntityComponentProps } from '~interfaces/props';
import { getAbsoluteUrl } from '~store/getter';

interface AudioProps extends IEntityComponentProps {
  controls: boolean;
  autoPlay?: false;
  showSkipControls?: boolean;
  showJumpControls?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
  style?: Object;
}

export const Audio = (props: AudioProps) => {
  const { autoPlay, data, style, controls } = props;

  const fieldFile = data?.attributes?.field_file;

  const onPause = () => {
    //called when the user pauses playback. Passed the event.
  };

  const onError = () => {
    //trigger modal for error
  };

  const onVolumeChanged = () => {
    //called when the user changes the volume, such as by dragging the volume slider
  };

  const onAbort = () => {
    //called when the user changes the volume, such as by dragging the volume slider
  };

  return (
    <ReactAudioPlayer
      style={style}
      onAbort={onAbort}
      src={getAbsoluteUrl(fieldFile?.fileURL)}
      autoPlay={autoPlay}
      onError={onError}
      controls={controls}
      onPause={onPause}
      onVolumeChanged={onVolumeChanged}
    />
  );
};

export default Audio;
